import React from "react";
import "./Popup.css";

import { useAppContext } from "../../classes/contexts/AppContext";

const Popup = () => {
  const { popupVisible, popupComponent } = useAppContext();

  return (
    popupVisible && (
      <div className="app-popup-overlay">
        <div className="app-popup-content">{popupComponent}</div>
      </div>
    )
  );
};

export default Popup;
